export const getSplitTextWithDots = (text: string, limit: number): string => {
  if (!text || !limit) return null

  if (text.length < limit - 5) return null

  const splittedText = text.slice(0, limit - 5)

  return splittedText !== text ? `${splittedText}...` : null
}
